(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vonare-tools"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const THEME_KEY = 'vonare-theme';
    const LIST_KEY = 'vonare-ulubione';
    const root = document.documentElement;
    const tools = document.getElementById('vonare-tools');
    if (!tools) return;

    const read = (key, fallback) => {
      try {
        const value = JSON.parse(localStorage.getItem(key));
        return value ?? fallback;
      } catch (e) {
        return fallback;
      }
    };
    const write = (key, value) => {
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch (e) {}
    };

    // Text is only written when it changes, so the MutationObserver below does not loop.
    const setText = (el, text) => {
      if (el.textContent !== text) el.textContent = text;
    };

    const icon = (paths) =>
      `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths}</svg>`;
    const HEART = '<path d="M12 20.5s-7.5-4.6-9.2-9.4C1.6 7.6 3.9 4.5 7.2 4.5c2 0 3.6 1.1 4.8 2.8 1.2-1.7 2.8-2.8 4.8-2.8 3.3 0 5.6 3.1 4.4 6.6-1.7 4.8-9.2 9.4-9.2 9.4z"/>';
    const MOON = '<path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5z"/>';
    const SUN = '<circle cx="12" cy="12" r="4"/><path d="M12 2.5v2M12 19.5v2M4.6 4.6l1.4 1.4M18 18l1.4 1.4M2.5 12h2M19.5 12h2M4.6 19.4 6 18M18 6l1.4-1.4"/>';
    const THEME_ICONS = icon(MOON).replace('<svg', '<svg class="vonare-icon-moon"') + icon(SUN).replace('<svg', '<svg class="vonare-icon-sun"');

    /* ---------- light / dark ---------- */
    const swapLogo = (dark) => {
      const darkSrc = tools.dataset.logoDark;
      if (!darkSrc) return;
      document.querySelectorAll('header img').forEach((img) => {
        const src = img.dataset.vonareLight || img.currentSrc || img.src;
        if (!/vonare-logo/.test(src)) return;
        if (!img.dataset.vonareLight) {
          img.dataset.vonareLight = img.src;
          img.dataset.vonareLightSet = img.srcset || '';
        }
        if (dark) {
          img.srcset = '';
          img.src = darkSrc;
        } else {
          img.srcset = img.dataset.vonareLightSet;
          img.src = img.dataset.vonareLight;
        }
      });
    };

    const applyTheme = (theme) => {
      const dark = theme === 'dark';
      if (dark) root.dataset.vonareTheme = 'dark';
      else delete root.dataset.vonareTheme;
      swapLogo(dark);
      document.querySelectorAll('.vonare-theme-toggle').forEach((button) => {
        button.setAttribute('aria-pressed', String(dark));
        button.setAttribute('aria-label', dark ? 'Włącz tryb jasny' : 'Włącz tryb ciemny');
        button.title = dark ? 'Tryb jasny' : 'Tryb ciemny';
        const label = button.querySelector('.vonare-drawer-theme__label');
        if (label) setText(label, dark ? 'Tryb jasny' : 'Tryb ciemny');
      });
    };

    const toggleTheme = () => {
      const next = root.dataset.vonareTheme === 'dark' ? 'light' : 'dark';
      try {
        localStorage.setItem(THEME_KEY, next);
      } catch (e) {}
      applyTheme(next);
    };

    /* ---------- favourites ---------- */
    const list = () => read(LIST_KEY, []);

    const toggleItem = (item) => {
      let items = list();
      if (items.some((i) => i.handle === item.handle)) items = items.filter((i) => i.handle !== item.handle);
      else items.unshift(item);
      write(LIST_KEY, items);
      refresh();
    };

    const syncHearts = () => {
      const items = list();
      document.querySelectorAll('.vonare-count').forEach((el) => setText(el, items.length ? String(items.length) : ''));
      document.querySelectorAll('.vonare-heart').forEach((button) => {
        const on = items.some((i) => i.handle === button.dataset.handle);
        button.setAttribute('aria-pressed', String(on));
        button.setAttribute('aria-label', on ? 'Usuń z ulubionych' : 'Dodaj do ulubionych');
        const label = button.querySelector('.vonare-heart__label');
        if (label) setText(label, on ? 'W ulubionych' : 'Dodaj do ulubionych');
      });
    };

    const refresh = () => {
      renderPage();
      syncHearts();
    };

    const heartButton = (handle, extraClass, withLabel) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `vonare-heart ${extraClass}`;
      button.dataset.handle = handle;
      button.innerHTML = icon(HEART) + (withLabel ? '<span class="vonare-heart__label"></span>' : '');
      return button;
    };

    const cardData = (card) => {
      const link = card.querySelector('a.product-card__link, a[href*="/products/"]');
      if (!link) return null;
      const match = new URL(link.href, location.origin).pathname.match(/\/products\/([^/?#]+)/);
      if (!match) return null;
      const img = card.querySelector('img');
      const price = card.querySelector('.vonare-price .price--sale, .vonare-price .price');
      return {
        handle: match[1],
        title: link.getAttribute('aria-label') || link.textContent.trim(),
        url: `/products/${match[1]}`,
        image: img ? img.currentSrc || img.src : '',
        price: price ? price.textContent.replace(/\s+/g, ' ').trim() : '',
      };
    };

    const decorateCards = () => {
      document.querySelectorAll('product-card:not([data-vonare-heart])').forEach((card) => {
        const data = cardData(card);
        if (!data) return;
        card.dataset.vonareHeart = '';
        const holder = card.querySelector('[ref="cardGallery"], .card-gallery') || card;
        if (getComputedStyle(holder).position === 'static') holder.style.position = 'relative';
        const button = heartButton(data.handle, 'vonare-heart--card', false);
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          toggleItem(cardData(card) || data);
        });
        holder.appendChild(button);
      });
    };

    const decorateProductPage = () => {
      const json = document.getElementById('vonare-current-product');
      if (!json || document.querySelector('.vonare-heart--page')) return;
      const form = document.querySelector('main form[action*="/cart/add"]');
      if (!form) return;
      let data;
      try {
        data = JSON.parse(json.textContent);
      } catch (e) {
        return;
      }
      const button = heartButton(data.handle, 'vonare-heart--page', true);
      button.addEventListener('click', () => toggleItem(data));
      const anchor = form.closest('product-form-component') || form;
      anchor.insertAdjacentElement('afterend', button);
    };

    const decorateHeader = () => {
      const actions = document.querySelector('header-actions');
      if (!actions || actions.querySelector('.vonare-header-btn')) return;
      const before = actions.querySelector('.account-button') || actions.firstElementChild;

      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'vonare-header-btn vonare-theme-toggle header-actions__action';
      toggle.innerHTML = THEME_ICONS;
      toggle.addEventListener('click', toggleTheme);

      const heart = document.createElement('a');
      heart.href = tools.dataset.wishlistUrl;
      heart.className = 'vonare-header-btn header-actions__action';
      heart.setAttribute('aria-label', 'Ulubione');
      heart.title = 'Ulubione';
      heart.innerHTML = icon(HEART) + '<span class="vonare-count"></span>';

      actions.insertBefore(toggle, before);
      actions.insertBefore(heart, before);
    };

    const decorateDrawer = () => {
      const links = document.querySelector('.menu-drawer__utility-links');
      if (!links || links.querySelector('.vonare-drawer-theme')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'vonare-theme-toggle vonare-drawer-theme';
      button.innerHTML = THEME_ICONS + '<span class="vonare-drawer-theme__label"></span>';
      button.addEventListener('click', toggleTheme);
      links.prepend(button);
      applyTheme(root.dataset.vonareTheme === 'dark' ? 'dark' : 'light');
    };

    /* ---------- favourites page ---------- */
    const renderPage = () => {
      const box = document.getElementById('vonare-wishlist');
      if (!box) return;
      const items = list();
      box.textContent = '';
      if (!items.length) {
        const p = document.createElement('p');
        p.className = 'vonare-wishlist__empty';
        p.innerHTML = 'Nie masz jeszcze ulubionych produktów. Kliknij serduszko przy produkcie, aby go tu dodać. <a href="/collections/all">Zobacz produkty</a>';
        box.appendChild(p);
        return;
      }
      const grid = document.createElement('div');
      grid.className = 'vonare-wishlist';
      items.forEach((item) => {
        const card = document.createElement('div');
        card.className = 'vonare-wishlist__item';
        const link = document.createElement('a');
        link.href = item.url;
        if (item.image) {
          const img = document.createElement('img');
          img.src = item.image;
          img.alt = item.title;
          img.loading = 'lazy';
          link.appendChild(img);
        }
        const title = document.createElement('span');
        title.className = 'vonare-wishlist__title';
        title.textContent = item.title;
        link.appendChild(title);
        card.appendChild(link);
        if (item.price) {
          const price = document.createElement('span');
          price.className = 'vonare-wishlist__price';
          price.textContent = item.price;
          card.appendChild(price);
        }
        const remove = heartButton(item.handle, 'vonare-heart--card', false);
        remove.addEventListener('click', () => toggleItem(item));
        card.appendChild(remove);
        grid.appendChild(card);
      });
      box.appendChild(grid);
    };

    /* ---------- start ---------- */
    const run = () => {
      decorateHeader();
      decorateDrawer();
      decorateCards();
      decorateProductPage();
      applyTheme(root.dataset.vonareTheme === 'dark' ? 'dark' : 'light');
      refresh();
    };

    // The theme re-renders parts of the header after load, so our additions are re-applied on DOM changes.
    // A timer (not requestAnimationFrame) keeps this working in tabs that are not being painted.
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      setTimeout(() => {
        queued = false;
        decorateHeader();
        decorateDrawer();
        decorateCards();
        decorateProductPage();
        swapLogo(root.dataset.vonareTheme === 'dark');
        syncHearts();
      }, 60);
    }).observe(document.body, { childList: true, subtree: true });

    window.addEventListener('storage', (event) => {
      if (event.key === LIST_KEY) refresh();
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
  })();

  } catch(e) { console.error(e); }
})();
})();
